import promiseComponent from './promise.vue';
const promise={
        install:function (Vue){
            Vue.component('promiseComponent',promiseComponent)
        }
}
export default promise


// WEBPACK FOOTER //
// ./src/components/global/promise/index.js